import { isNotNullOrUndefined } from "../../utils/helpers/stringHelper";

export const extractValue = (clientData, fieldName) =>
  isNotNullOrUndefined(clientData.clientDetails[fieldName]) ? clientData.clientDetails[fieldName] : "";